import { axiosInstance } from './api';

// Гостевой Wi-Fi (W2): собираем статистику с роутера филиала.

export interface WifiSettingsDto {
  enabled: boolean;
  has_router: boolean;
  router_ready: boolean;
  router_model: string;
  sessions: number;
  /** Какие сети считаем; пусто — все. */
  networks: string[];
}

/** Сеть роутера как её видит управляющий (AI29/AI31). */
export interface WifiNetworkDto {
  interface: string;
  key: string;
  title: string;
  guest: boolean;
  ssids: string[];
  access_points: { ssid: string; band: string; encryption: string; up: boolean }[];
  open: boolean;
  up: boolean;
  captive: { interface: string; uam_server: string; profile: string; ours: boolean; up: boolean } | null;
}

export interface WifiStatsDto {
  from: string;
  to: string;
  visits: number;
  devices: number;
  guest_share: number | null;
  repeat_share: number | null;
  median_minutes: number | null;
  by_kind: Record<string, number>;
  by_band: Record<string, number>;
  by_network: Record<string, number>;
  top_vendors: Record<string, number>;
  per_day: Record<string, number>;
  /** Час суток (0–23) → сколько устройств в среднем было в сети в этот час. */
  by_hour: Record<string, number>;
  /** День недели (0 = понедельник) → сколько подключений в среднем за такой день. */
  by_weekday: Record<string, number>;
  /** Подпись корзины длительности → сколько подключений в неё попало. */
  by_dwell: Record<string, number>;
}

export const getWifiSettings = (zoneId: string | number) =>
  axiosInstance.get<WifiSettingsDto>(`/equipment_discovery/zones/${zoneId}/wifi/`);

export const setWifiEnabled = (zoneId: string | number, enabled: boolean) =>
  axiosInstance.put<{ enabled: boolean; probe?: { clients: number; error: string } }>(
    `/equipment_discovery/zones/${zoneId}/wifi/`, { enabled });

export const getWifiNetworks = (zoneId: string | number) =>
  axiosInstance.get<{ networks: WifiNetworkDto[]; counted: string[]; error: string }>(
    `/equipment_discovery/zones/${zoneId}/wifi/networks/`);

export const setWifiNetworks = (zoneId: string | number, networks: string[]) =>
  axiosInstance.put<{ networks: string[] }>(`/equipment_discovery/zones/${zoneId}/wifi/`, { networks });

export const getWifiStats = (zoneId: string, from: string, to: string) =>
  axiosInstance.get<WifiStatsDto>(`/equipment_discovery/zones/${zoneId}/wifi/stats/`, { params: { from, to } });
